"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleModeFromBlank = void 0;
var toggleModeFromBlank = function (utils) {
    var a11yHasExpectedHtml = utils.a11yHasExpectedHtml, hasReturnVal = utils.hasReturnVal, loadPrimaryInput = utils.loadPrimaryInput, use = utils.use;
    describe('Mode - BLANK toggle', function () {
        it('UP from blank mode', function () {
            loadPrimaryInput({ segment: 'mode' })
                .then(use.del)
                .then(use.upArrow)
                .should('have.value', '08:30 AM')
                .then(a11yHasExpectedHtml("<p>AM.</p>"))
                .then(hasReturnVal('08:30'));
        });
        it('DOWN from blank mode', function () {
            loadPrimaryInput({ segment: 'mode' })
                .then(use.del)
                .then(use.downArrow)
                .should('have.value', '08:30 PM')
                .then(a11yHasExpectedHtml("<p>PM.</p>"))
                .then(hasReturnVal('20:30'));
        });
    });
};
exports.toggleModeFromBlank = toggleModeFromBlank;
